import {Observable, Subscription} from 'rxjs';

import IVolumeStore from '../Interfaces/IVolumeStore';

const subscribeToVolumeSliderTap = (
    volumeSliderTap$: Observable<number>,
    volumeStore: IVolumeStore
): Subscription =>
    volumeSliderTap$
        .subscribe((multiplier) => volumeStore.actions.setLevel(multiplier));

export default subscribeToVolumeSliderTap;